import {
  CalendarDays,
  Filter,
  X,
} from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Badge } from "../ui/badge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export const ReportsFilterBar = ({
  dateFrom,
  setDateFrom,
  dateTo,
  setDateTo,
  selectedCoord,
  setSelectedCoord,
  activeFrom,
  activeTo,
  activeCoord,
  setActiveCoord,
  coordinators,
  onApply,
  onClear,
  onPreset,
}) => (
  <div className="flex items-end gap-3 flex-wrap p-3 rounded-lg" style={{ background: "var(--t-bg)", border: "1px solid var(--t-border)" }} data-testid="date-filter">
    <div className="flex items-center gap-1.5">
      <CalendarDays className="w-4 h-4" style={{ color: "var(--t-text-muted)" }} />
      <span className="text-xs font-semibold uppercase tracking-wider" style={{ color: "var(--t-text-muted)" }}>Date Range</span>
    </div>
    <div className="flex items-end gap-2">
      <div>
        <label className="text-[10px] uppercase tracking-wider block mb-0.5" style={{ color: "var(--t-text-subtle)" }}>From</label>
        <Input
          type="date"
          value={dateFrom}
          onChange={(e) => setDateFrom(e.target.value)}
          className="h-8 text-xs w-[140px]"
          data-testid="date-from"
        />
      </div>
      <div>
        <label className="text-[10px] uppercase tracking-wider block mb-0.5" style={{ color: "var(--t-text-subtle)" }}>To</label>
        <Input
          type="date"
          value={dateTo}
          onChange={(e) => setDateTo(e.target.value)}
          className="h-8 text-xs w-[140px]"
          data-testid="date-to"
        />
      </div>
      <Button size="sm" className="h-8 text-xs bg-[var(--t-primary)] hover:bg-[var(--t-primary-hover)]" onClick={onApply} data-testid="apply-date-filter">
        <Filter className="w-3 h-3 mr-1" /> Apply
      </Button>
    </div>
    <div className="flex items-center gap-1.5 ml-1">
      {[
        { label: "30d", days: 30 },
        { label: "90d", days: 90 },
        { label: "6mo", days: 180 },
        { label: "1yr", days: 365 },
      ].map((p) => (
        <Button
          key={p.label}
          variant="outline"
          size="sm"
          className="h-7 text-[10px] px-2"
          onClick={() => onPreset(p.days)}
          data-testid={`preset-${p.label}`}
        >
          {p.label}
        </Button>
      ))}
    </div>
    {/* Coordinator Filter */}
    {coordinators.length > 0 && (
      <div>
        <label className="text-[10px] uppercase tracking-wider block mb-0.5" style={{ color: "var(--t-text-subtle)" }}>Coordinator</label>
        <Select value={selectedCoord} onValueChange={(v) => { setSelectedCoord(v); setActiveCoord(v); }}>
          <SelectTrigger className="h-8 text-xs w-[180px]" data-testid="reports-coordinator-select">
            <SelectValue placeholder="All Coordinators" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Coordinators</SelectItem>
            {coordinators.map((c) => (
              <SelectItem key={c.user_id} value={c.user_id}>
                {c.name || c.email}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    )}
    {(activeFrom || activeTo) && (
      <Badge variant="secondary" className="text-[10px] h-5">
        Filtered: {activeFrom || "..."} to {activeTo || "..."}
      </Badge>
    )}
    {activeCoord !== "all" && (
      <Badge variant="secondary" className="text-[10px] h-5">
        {coordinators.find(c => c.user_id === activeCoord)?.name || "Coordinator"}
      </Badge>
    )}
    {(activeFrom || activeTo || activeCoord !== "all") && (
      <Button variant="ghost" size="sm" className="h-7 text-xs text-red-600 hover:text-red-700" onClick={onClear} data-testid="clear-date-filter">
        <X className="w-3 h-3 mr-1" /> Clear
      </Button>
    )}
  </div>
);
